import cc from 'classcat';
import { observer } from 'mobx-react';
import numabbr from 'numabbr';
import * as React from 'react';
import CountUp from 'react-countup';
import styles from './Talks.styl';

interface StatsElementProps {
    icon: string;
    value: number;
    label: string;
    className?: string;
}

@observer
export class StatsElement extends React.Component<StatsElementProps> {
    render() {
        const { icon, value, label, className } = this.props;
        const countUpProps: ReactCountUp.Props = {
            end: value,
            delay: 1,
            duration: 3 + Math.random() * 3,
            easingFn: (t, b, c, d) => c * Math.sqrt(1 - (t = t / d - 1) * t) + b,
            formattingFn: value => value ? numabbr(value, { precision: 0 }) : '∞',
        };

        return (
            <div className={cc([styles.statcolumn, className])}>
                <div className={styles.icon}><img src={icon} /></div>
                <div className={styles.value}>{value ? <CountUp {...countUpProps} /> : <Placeholder />}</div>
                <div className={styles.label}>{label}</div>
            </div>
        );
    }
}

const Placeholder = () => {
    const style = { opacity: 0.2 };
    return (
        <span style={style}>∞</span>
    );
};
